import { UserTimecard } from '@app/models';
import { createAction, props } from '@ngrx/store';

export const loadMultipleTimeCardsSuccess = createAction(
  '[Multiple Timecards API] Load Success',
  props<{ payload: UserTimecard[] }>()
);
